import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import useCatalogo from "../../../hooks/useCatalogos"
import { useDispatch, useSelector } from "react-redux"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { obtenerFacturaHistorialFiltroAction } from "../../../ducks/facturacionHistorialDuck"
const FiltroEstatusFacturas = () => {
    const catEstatusFacturas = useCatalogo("Invoice/Status")
    const { filtroEstatus } = useSelector(store => store.facturasHistorial)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerFacturaHistorialFiltroAction({filtroEstatus:  event.target.value})).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <FormControl variant="outlined">
            <InputLabel id="Filtro-estatus-select-devolcuon-label">Filtro</InputLabel>
            <Select
                labelId="Filtro-estatus-select-devolcuon-label"
                id="Filtro-estatus-select-devolcuon"
                value={filtroEstatus}
                onChange={handleChange}
                label="Filtro"
            >
                {
                    catEstatusFacturas.map((valor, index) => {
                        return (
                            <MenuItem key={valor.IdCatEstatusFactura} value={valor.IdCatEstatusFactura}>
                                {valor.Descripcion}
                            </MenuItem>
                        )
                    })
                }
            </Select>
        </FormControl>
    )
}
export default FiltroEstatusFacturas